import { create } from 'zustand';
import { LOCALES } from '../locales/locales';
export var useLocaleStore = create(function (set) { return ({
    locale: LOCALES.ENGLISH,
    setLocale: function (newLocale) { return set({ locale: newLocale }); },
}); });
